export default {"src":"/_next/static/media/x-logo-horizontal.cea2a67c.svg","height":27,"width":95};